import type { IconProps } from '@carboncopyco/icons';
import classNames from 'classnames';
import type React from 'react';
import { Spacer } from '../Spacer';
import { TextBase } from '../Typography';

export interface DropdownMenuItemProps {
  id?: string;
  label?: string | React.ReactNode;
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  iconLeft?: React.ReactElement<IconProps>;
  iconRight?: React.ReactElement<IconProps>;
  children?: React.ReactElement<IconProps>;
  disabled?: boolean;
  hidden?: boolean;
  width?: number;
}

export const DropdownMenuItem = ({
  label,
  onClick,
  iconLeft,
  iconRight,
  children,
  disabled,
  hidden,
  width,
}: DropdownMenuItemProps) => {
  return !hidden ? (
    <div
      data-testid={label}
      style={{
        width: width ? `${width}px` : '100%',
      }}
      onClick={!disabled ? onClick : undefined}
    >
      {children ? (
        children
      ) : (
        <div
          className={classNames([
            disabled && 'cursor-default bg-ds-accent3-100',
            !!onClick &&
              !disabled &&
              'hover:bg-ds-natural-50 hover:rounded cursor-pointer',
            'flex items-center justify-between rounded p-2.5',
          ])}
        >
          <div className="flex items-center justify-start overflow-hidden">
            {iconLeft && (
              <div
                className={classNames([
                  'flex items-center',
                  'mr-2 text-ds-natural-600',
                  disabled && 'text-ds-natural-200',
                ])}
              >
                {iconLeft}
              </div>
            )}
            <div
              className={classNames(
                'truncate select-none text-ds-natural-600',
                {
                  'text-ds-natural-200': disabled,
                }
              )}
            >
              {typeof label === 'string' ? (
                <TextBase
                  label={label}
                  color={
                    disabled ? 'text-ds-natural-200' : 'text-ds-natural-600'
                  }
                  ellipsis
                />
              ) : (
                label
              )}
            </div>
            <Spacer amount={0.75} />
          </div>
          {iconRight && <div>{iconRight}</div>}
        </div>
      )}
    </div>
  ) : null;
};
